<script setup lang="ts">
import { NXGDSButton, NXGDSButtonVariants } from '@nsftx/seven-nxg-design-system'

const { title, backLabel, showCloseButton = false } = defineProps<{
  title: string
  backLabel?: string
  showCloseButton?: boolean
}>()

const emit = defineEmits<{
  toggleMenuClick: []
  backClick: []
}>()
</script>

<template>
  <div class="nxg-retail-pos-page-header" data-testid="nxg-retail-pos-page-header">
    <div class="nxg-retail-pos-page-header__leading">
      <div class="nxg-retail-pos-page-header__toggle-menu">
        <NXGDSButton size="md" icon="menu-a" @click="emit('toggleMenuClick')" />
      </div>
      <div class="nxg-retail-pos-page-header__title">
        <span class="nxgds-type-h4-regular">{{ title }}</span>
      </div>
    </div>
    <NXGDSButton
      v-if="showCloseButton"
      class="nxg-retail-pos-page-header__back"
      :variant="NXGDSButtonVariants.secondary"
      icon="close-a"
      size="md"
      data-testid="nxg-retail-pos-page-header-close"
      @click="emit('backClick')"
    />
    <NXGDSButton
      v-else-if="backLabel"
      class="nxg-retail-pos-page-header__back"
      data-testid="nxg-retail-pos-page-header-back"
      @click="emit('backClick')"
    >
      {{ backLabel }}
    </NXGDSButton>
  </div>
</template>

<style scoped lang="scss">
.nxg-retail-pos-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--nxgds-mapped-color-surface-component-card-default);
  border-radius: var(--nxgds-alias-radius-corner-sm);
  padding: var(--nxgds-alias-spacing-xs);

  &__leading {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__toggle-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  &__title {
    display: flex;
    align-items: center;
    padding-left: var(--nxgds-alias-spacing-sm);
    color: var(--nxgds-mapped-color-text-primary);
  }

  &__back {
    flex-shrink: 0;
    margin-left: auto;
  }
}
</style>
